import React__default from 'react';
import HeroSliderModuleCss from './HeroSlider.module.css.js';
import Buttons from './components/Buttons/index.js';
import { SettingsProvider, useSettings } from './modules/Settings.js';
import { AnimationsProvider, useAnimations } from './modules/Animations.js';
import { ControllerProvider, useController } from './modules/Controller.js';
import { LayoutProvider, useLayout } from './modules/Layout.js';
import { AccessabilityProvider, useAccessability } from './modules/Accessability.js';
import { AutoplayProvider, useAutoplay } from './modules/Autoplay.js';
import { ManagerProvider } from './modules/Manager.js';
import { IntersectionObserverProvider, useIntersectionObserver } from './modules/IntersectionObserver.js';
import { composeCssClasses } from './utils/composeCssClasses.js';
import ConsoleLogger from './modules/ConsoleLogger.js';
var logger = ConsoleLogger.new();

function Orchestrator(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100vh' : _ref$height,
      style = _ref.style,
      children = _ref.children;
  logger.info('[Orchestrator] rerender');

  var _useAccessability = useAccessability(),
      shouldDisplayButtons = _useAccessability.shouldDisplayButtons;

  var _useAnimations = useAnimations(),
      sliderFadeInDuration = _useAnimations.sliderFadeInDuration,
      navbarFadeInDuration = _useAnimations.navbarFadeInDuration,
      navbarFadeInDelay = _useAnimations.navbarFadeInDelay;

  var _useLayout = useLayout(),
      layout = _useLayout.state;

  var _useController = useController(),
      slidingDuration = _useController.slidingDuration,
      slidingDelay = _useController.slidingDelay,
      getSlidingCycleDuration = _useController.getSlidingCycleDuration;

  var settings = useSettings();

  var _useAutoplay = useAutoplay(),
      debounce = _useAutoplay.debounce;

  var _useAccessability2 = useAccessability(),
      onTouchStartHandler = _useAccessability2.onTouchStartHandler,
      onTouchMoveHandler = _useAccessability2.onTouchMoveHandler,
      onTouchEndHandler = _useAccessability2.onTouchEndHandler;

  var _useIntersectionObser = useIntersectionObserver(),
      elementObservedRef = _useIntersectionObser.elementObservedRef;
  /**
   * CSS variables for the transitions.
   */


  var CSSVariables = {
    '--sliding-duration': "".concat(slidingDuration, "ms"),
    '--sliding-delay': "".concat(slidingDelay, "ms"),
    '--slide-transition-delay': "".concat(getSlidingCycleDuration(), "ms"),
    '--slider-width': layout.width ? "".concat(layout.width, "px") : undefined,
    '--slider-height': layout.height ? "".concat(layout.height, "px") : undefined,
    '--slider-color': settings.sliderColor,
    '--slider-fade-in-duration': "".concat(sliderFadeInDuration, "ms"),
    '--nav-fade-in-duration': "".concat(navbarFadeInDuration, "ms"),
    '--nav-fade-in-delay': "".concat(navbarFadeInDelay, "ms"),
    '--nav-background-color': settings.navbarStyle ? settings.navbarStyle.color : undefined,
    '--nav-active-color': settings.navbarStyle ? settings.navbarStyle.activeColor : undefined,
    '--mask-duration': "".concat(getSlidingCycleDuration(), "ms")
  };
  return React__default.createElement("div", {
    className: composeCssClasses('hero-slider-root', className),
    ref: elementObservedRef
  }, React__default.createElement("div", {
    ref: layout.slider,
    className: composeCssClasses('hero-slider-wrapper', HeroSliderModuleCss.Wrapper),
    onTouchStart: onTouchStartHandler,
    onTouchMove: onTouchMoveHandler,
    onTouchEnd: onTouchEndHandler,
    onMouseMoveCapture: debounce,
    style: Object.assign(Object.assign(Object.assign({}, CSSVariables), style), {
      width: width,
      height: height
    })
  }, children, shouldDisplayButtons && React__default.createElement(Buttons, null)));
}

function HeroSlider(props) {
  return React__default.createElement(LayoutProvider, null, React__default.createElement(ManagerProvider, {
    manager: props.manager
  }, React__default.createElement(SettingsProvider, {
    settings: props.settings
  }, React__default.createElement(ControllerProvider, {
    controller: props.controller
  }, React__default.createElement(AccessabilityProvider, {
    accessability: props.accessability
  }, React__default.createElement(AnimationsProvider, {
    animations: props.animations
  }, React__default.createElement(IntersectionObserverProvider, null, React__default.createElement(AutoplayProvider, {
    autoplay: props.autoplay
  }, React__default.createElement(Orchestrator, {
    className: props.className,
    width: props.width,
    height: props.height,
    style: props.style
  }, props.children)))))))));
}

export { HeroSlider as default };